import { IServices, MoneyType as OriginMoneyType } from "@netent/origin";
import { ISettingState, MoneyType } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const moneyTypesState: FeatureStateCreator<MoneyType[]> = (
  services: IServices
): MoneyType[] => {
  const originMoneyTypes: OriginMoneyType[] = services.money.getTypes();
  const moneyTypes: MoneyType[] = [];

  if (originMoneyTypes.includes("cash")) {
    moneyTypes.push(MoneyType.CASH);
  }

  if (originMoneyTypes.includes("coins")) {
    moneyTypes.push(MoneyType.COINS);
  }

  return moneyTypes;
};

export const moneyTypeState: FeatureStateCreator<MoneyType> = (
  services: IServices
): MoneyType => {
  const originMoneyType: OriginMoneyType = services.money.getType();

  if (originMoneyType === "coins") {
    return MoneyType.COINS;
  }

  return MoneyType.CASH;
};

export const moneyTypeAsSetting = (services: IServices): ISettingState => {
  const { language, money } = services;

  return {
    key: "isCash",
    name: language.getText("setting_isCash"),
    value: money.getType() === "cash"
  };
};
